/*----- Core -----*/
import React  from 'react'
import styled from 'styled-components'

/*----- Components -----*/
import SnnLogo from '../../../assets/landing_page/ssn_logo.png'

/*----- Commons -----*/
import Montserrat from '../../../commons/mixins/fonts/Montserrat'
import Device 		from '../../../commons/Device'

/*----- Styles -----*/
const StyledHeader = styled.footer`
	background-color: #58595b;
	padding: 16px 32px;
	display: flex;
	a {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 100%;
	}
	img {
		height: 32px;
		margin-right: 8px;
	}
	p {
		margin: 0 0 0 16px;
		${ Montserrat(12, 400,'white') };
	}
	@media ${Device.md} {
		a {
			flex-direction: row;
		}
	}
`

/*----- Component -----*/
const Header = () => {

	return(
		<StyledHeader className="app-header">
			<a href="www.argentina.gob.ar/ssn" target="_blank" rel="noopener noreferrer" className="app-header__whatsaap-button">
				<img src={SnnLogo} alt="whatsapp logo"/>
				<p>Organismo de control www.argentina.gob.ar/ssn</p>
			</a>
		</StyledHeader>
	)
}


export default Header
